import { PureComponent } from 'react';
import { connect } from 'react-redux';
import emptyFunction from 'react-utils/emptyFunction';
import unescapedText from 'I18n/utils/unescapedText';
import { addValidationError, removeValidationError } from 'ContentData/actions/ValidationErrors';
import UIExpandingTextArea from 'UIComponents/input/UIExpandingTextArea';
// @ts-expect-error no types yet
import withDebouncedInput from 'ContentComponents/decorators/withDebouncedInput';
import PickersContext from 'ContentComponents/context/PickersContext';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIInputGroup from 'UIComponents/form/UIInputGroup';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
// @ts-expect-error no types yet
import EmojiPickerWrapper from 'ui-addon-emoji-picker/picker/EmojiPickerWrapper';
import SanitizedLabel from 'ContentComponents/cmv2/SanitizedLabel';
import { getConfig } from 'tinymce-config/configs/editors/personalization-field';
// @ts-expect-error no types yet
import TinyMCE from 'react-tinymce';
import { CONTACT_FQN, COMPANY_FQN } from 'rich-text-lib/constants/properties';
import { compose } from 'redux';
import UISection from 'UIComponents/section/UISection';
import { getEncodedValue } from 'tinymce-config/utils/handlers';
import PersonalizationEditorContext from 'ContentComponents/context/PersonalizationEditorContext';
import Routes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DebounceUIExpandingTextArea = withDebouncedInput(UIExpandingTextArea);
const i18nKey = key => `ContentComponents.cmv2.fields.text.${key}`;
const mapDispatchToProps = {
  addValidationError,
  removeValidationError
};
const connector = connect(undefined, mapDispatchToProps);
const withPickersContext = WrappedComponent => props => /*#__PURE__*/_jsx(PickersContext.Consumer, {
  children: pickerComponents => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
    pickerComponents: pickerComponents
  }, props))
});
class TextField extends PureComponent {
  constructor(props) {
    super(props);
    this.renderBaseTextField = () => {
      const {
        error = false,
        fieldKey = [],
        readOnly = false,
        value = '',
        placeholder,
        useOnDark
      } = this.props;
      return /*#__PURE__*/_jsx(DebounceUIExpandingTextArea, {
        "data-selenium": fieldKey.join('.'),
        error: error,
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        maxHeight: 300,
        placeholder: placeholder,
        readOnly: readOnly,
        shrink: true,
        use: useOnDark ? 'on-dark' : 'default',
        value: value || ''
      });
    };
    this.renderPersonalizationTextField = () => {
      const {
        allow_new_line: allowNewLine = false,
        fieldKey = [],
        readOnly = false,
        value: dirtyValue = ''
      } = this.props;
      let value = dirtyValue;
      // If the field is using inheritance we get value object
      if (typeof value === 'object') {
        value = value.value;
      }
      return /*#__PURE__*/_jsx(PersonalizationEditorContext.Consumer, {
        children: ({
          __editorRefs,
          setEditorRefs
        }) => {
          const updateTinyMceRef = ref => {
            setEditorRefs(fieldKey.join('.'), ref);
          };
          return /*#__PURE__*/_jsx(UISection, {
            "data-test-id": fieldKey.join('.'),
            children: /*#__PURE__*/_jsx(TinyMCE, {
              "data-selenium": fieldKey.join('.'),
              config: this.config,
              content: getEncodedValue(value),
              isMultiline: allowNewLine,
              onBlur: this.onKeyPress,
              onChange: this.onChange,
              onKeyPress: this.onKeyPress,
              readOnly: readOnly,
              tinyMceRef: updateTinyMceRef,
              uniqueKey: fieldKey.join('.')
            })
          });
        }
      });
    };
    this.onChange = this.onChange.bind(this);
    this.validateRegex = this.validateRegex.bind(this);
    this.toggleEmojiPickerOpenState = this.toggleEmojiPickerOpenState.bind(this);
    this.onEmojiPickerOpenChange = this.onEmojiPickerOpenChange.bind(this);
    this.onEmojiSelect = this.onEmojiSelect.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.makeConfig = this.makeConfig.bind(this);
    this.config = this.makeConfig();
    this.state = {
      emojiPickerOpen: false
    };
  }
  componentDidMount() {
    const {
      value = ''
    } = this.props;
    if (value) this.validateRegex(value);
  }
  componentDidUpdate(prevProps) {
    const {
      error: prevError = false
    } = prevProps;
    const {
      error = false,
      fieldKey = []
    } = this.props;
    if (prevError && !error) this.props.removeValidationError(fieldKey);
  }
  get hasDataTokenPicker() {
    const {
      allow_data_tokens: allowDataTokens = false
    } = this.props;
    return allowDataTokens && Routes.isUngated('CMv2:DataTokenPicker');
  }
  makeConfig() {
    const {
      gates = [],
      pickerComponents,
      scopes = [],
      allow_new_line: allowNewLine = false
    } = this.props;
    const supportedCrmObjectFQNs = [CONTACT_FQN];
    if (scopes.includes('crm-product')) {
      supportedCrmObjectFQNs.push(COMPANY_FQN);
    }
    return getConfig({
      appName: '',
      gates,
      scopes,
      hideTokenFallbacks: false,
      pickerComponents,
      supportedCrmObjectFQNs,
      isMultiline: allowNewLine
    });
  }
  toggleEmojiPickerOpenState() {
    this.setState({
      emojiPickerOpen: !this.state.emojiPickerOpen
    });
  }
  onEmojiPickerOpenChange({
    target: {
      value
    }
  }) {
    this.setState({
      emojiPickerOpen: value
    });
  }
  onChange(e) {
    const {
      onFieldChange,
      allow_new_line: allowNewLine = false
    } = this.props;
    let value = this.hasDataTokenPicker ? e.target.getContent() : e.target.value;
    if (value && !allowNewLine) {
      value = value.replace(/[\n\r]+/g, '');
    }
    onFieldChange(value);
    this.validateRegex(value);
  }
  onKeyPress(e) {
    const {
      allow_new_line: allowNewLine = false
    } = this.props;
    if (e.key === 'Enter' && !allowNewLine) e.preventDefault();
  }
  onEmojiSelect({
    native
  }) {
    const {
      onFieldChange,
      value = ''
    } = this.props;
    onFieldChange(`${value}${native}`);
  }
  validateRegex(value) {
    const {
      validation_regex: validationRegex = null,
      validation_error_message: validationErrorMessage,
      setError = emptyFunction,
      required = false,
      fieldKey = []
    } = this.props;
    if (!validationRegex || value.match(`^${validationRegex}$`) || !value && !required) {
      setError(null);
    } else {
      const sanitizedValidationErrorMessage = validationErrorMessage && /*#__PURE__*/_jsx(SanitizedLabel, {
        label: validationErrorMessage,
        useStrict: true
      });
      setError(sanitizedValidationErrorMessage || unescapedText(i18nKey('invalidFormat'), {
        text: value,
        regex: validationRegex
      }));
      this.props.addValidationError(fieldKey);
    }
  }
  renderEmojiPicker() {
    const {
      show_emoji_picker = false
    } = this.props;
    if (!show_emoji_picker) return null;
    return /*#__PURE__*/_jsx(UIFormControl, {
      className: "emoji-picker",
      children: /*#__PURE__*/_jsx(PickersContext.Consumer, {
        children: ({
          EmojiPicker
        }) => EmojiPicker && /*#__PURE__*/_jsx(EmojiPickerWrapper, {
          popoverProps: {
            placement: 'bottom left',
            open: this.state.emojiPickerOpen,
            closeOnOutsideClick: true,
            onOpenChange: this.onEmojiPickerOpenChange
          },
          autoFocus: true,
          onClick: this.onEmojiSelect,
          useDefaultFilter: true,
          PickerContent: EmojiPicker,
          children: /*#__PURE__*/_jsx(UIIconButton, {
            use: this.props.useOnDark ? 'primary-white' : 'transparent',
            onClick: this.toggleEmojiPickerOpenState,
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "emoji"
            })
          })
        })
      })
    });
  }
  render() {
    const {
      show_emoji_picker = false
    } = this.props;
    const input = this.hasDataTokenPicker ? this.renderPersonalizationTextField() : this.renderBaseTextField();
    if (show_emoji_picker) {
      return /*#__PURE__*/_jsxs(UIInputGroup, {
        use: "itemRight",
        className: "cmv2-text-field",
        children: [/*#__PURE__*/_jsx(UIFormControl, {
          children: input
        }), this.renderEmojiPicker()]
      });
    }
    return input;
  }
}
export default compose(connector, withPickersContext)(TextField);